import { $Q, $Qll } from "../utils/query-selector";

let stickyCartEventsBound = false;

/**
 * Evaluates if is located in product page
 * and proceed to check window size
 */
export const stickyCart = () => {
  if(typeof window === 'undefined') return;
  if(!$Q('.sticky-cart')) return;

  checkWindowSize();
}

/**
 * Adds load and resize event listeners and
 * executes scroll event
 */
const checkWindowSize = () => {
  setStickyCartState();

  if(stickyCartEventsBound) return;

  stickyCartEventsBound = true;

  window.addEventListener('load', () => {
    setStickyCartState();
  });

  window.addEventListener('resize', () => {
    setStickyCartState();
  });

  window.addEventListener('scroll', () => {
    setStickyCartState();
  });
}

/**
 * Hides or shows the sticky cart depending on its customizer mode.
 */
const setStickyCartState = () => {
  const stickyCart = $Q('.sticky-cart');
  const stickyCartNav = $Q('[data-sticky-cart-nav]', stickyCart);

  if(!stickyCart) return;

  if(stickyCartNav?.dataset.alwaysVisible === 'true') {
    stickyCart.classList.remove('not-sticky');
    return;
  }

  stickyCartByMainButton(stickyCart);
}

/**
 * Hides or shows the sticky cart depending on the main add-to-cart position.
 * @param {HTMLElement} stickyCart
 */
const stickyCartByMainButton = (stickyCart) => {
  const mainSection = $Q('.main-product');
  const button = $Q('.btn-add-to-cart', mainSection);

  if(!button) {
    stickyCart.classList.add('not-sticky');
    return;
  }

  if(button.getBoundingClientRect().bottom < 0) {
    stickyCart.classList.remove('not-sticky');
  } else {
    stickyCart.classList.add('not-sticky');
  }
}

/**
 * Synchronizes sticky price
 */
export const syncStickyPrice = () => {
  const subscriptions = $Q('.main-product__subscriptions');
  const stickyPrice = $Q('.sticky-cart__price');

  if(!subscriptions) {
    setStickySubscriptionPrice(null, stickyPrice);
  } else {
    setStickySubscriptionPrice(subscriptions, stickyPrice);
  }
}

/**
 * Set the sticky price based on main product price from subscriptions
 * @param {Document} parent - It is the parent in DOM
 * @param {HTMLElement} stickyPrice - It is the sticky price element
 */
const setStickySubscriptionPrice = (parent, stickyPrice) => {
  const baseQuery = '.main-product__subscriptions';
  const subscriptionWrapper = $Q(
    `${baseQuery}-wrapper[data-active="true"]`,
    parent);
  let mainPrice = $Q(
    `${baseQuery}-price`,
    parent ? subscriptionWrapper : null);
    if (!mainPrice) {
      mainPrice = $Q(
        `${baseQuery}-discount-price`,
        parent ? subscriptionWrapper : null);
    }
  if(!stickyPrice || !mainPrice) return;
    stickyPrice.innerText = mainPrice.innerText.trim();

  setVariantPrice(mainPrice);
}

/**
 * It assigns the price to button add to cart
 * @param {HTMLElement} mainPrice - Element with price
 */
const setVariantPrice = (mainPrice) => {
  const variantPrice = $Qll('#variant-price');

  if(!variantPrice) return;

  variantPrice.forEach(price => {
    price.innerText = `${mainPrice.innerText.trim()}`;
  })
}
